import React, { Component } from 'react';
import './calc.css'; // Import the CSS file

class Buttons extends Component {
    constructor(props) {
        super(props);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown(event) {
        const keyValue = event.key;
        if (/^\d$/.test(keyValue) || ['+', '-', '*', '/', 'enter', 'backspace', 'c'].includes(keyValue)) {
            this.props.Buttonclicked(keyValue);
        } else if (keyValue === 'Backspace') {
            this.props.Buttonclicked('c'); // Sending 'c' for clear as a backspace action
        } else if (keyValue === 'Enter'){
            this.props.Buttonclicked('=');
        }
    }

    handleClicks = (event) => {
        this.props.Buttonclicked(event.target.value);
    }

    render() {
        return (
            <div className="parent">
                <button className="div1 btn btn-action" onClick={this.handleClicks} value="AC">AC</button>
                <button className="div5 btn" onClick={this.handleClicks} value="7">7</button>
                <button className="div10 btn" onClick={this.handleClicks} value="4">4</button>
                <button className="div13 btn" onClick={this.handleClicks} value="1">1</button>
                <button className="div17 btn-0 btn btn-zero" onClick={this.handleClicks} value="0">0</button>
                <button className="div2 btn btn-action" onClick={this.handleClicks} value="+/-">+/-</button>
                <button className="div6 btn" onClick={this.handleClicks} value="8">8</button>
                <button className="div11 btn" onClick={this.handleClicks} value="5">5</button>
                <button className="div14 btn" onClick={this.handleClicks} value="2">2</button>
                <button className="div3 btn btn-calc" onClick={this.handleClicks} value="%">%</button>
                <button className="div7 btn" onClick={this.handleClicks} value="9">9</button>
                <button className="div12 btn" onClick={this.handleClicks} value="6">6</button>
                <button className="div16 btn" onClick={this.handleClicks} value="3">3</button>
                <button className="div18 btn" onClick={this.handleClicks} value=".">.</button>
                <button className="div4 btn btn-calc" onClick={this.handleClicks} value="/">÷</button>
                <button className="div8 btn btn-calc" onClick={this.handleClicks} value="*">x</button>
                <button className="div9 btn btn-calc" onClick={this.handleClicks} value="-">-</button>
                <button className="div15 btn btn-calc" onClick={this.handleClicks} value="+">+</button>
                <button className="div19 btn btn-calc" onClick={this.handleClicks} value="=">=</button>
            </div>
        );
    }
}

export default Buttons;



// WEBPACK FOOTER //
// ./src/component/buttons.jsx